import React, { useContext } from 'react'
import { yupResolver } from '@hookform/resolvers/yup'
import { Controller, useForm } from 'react-hook-form'
import { addClient, editClient } from '../../redux/slices/clientSlice'
import { useDispatch } from 'react-redux'
import { SpinnerContext } from '../../context/spinnerContext'
import { clientsSchema } from '../../util/validationSchema'
import { errorToast, successToast } from '../../util/Toast/toast'
import { capitalizeFirstLetter } from '../../helper/function'

const AddEditGhostClient = ({ clientID, editData, toggle, setIsRefresh }) => {
  const dispatch = useDispatch()
  const { changeLoader } = useContext(SpinnerContext)

  const {
    handleSubmit,
    control,
    trigger,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(clientsSchema),
    defaultValues: {
      first_name: editData ? editData?.first_name : '',
      last_name: editData ? editData?.last_name : ''
    }
  })

  const onSubmit = (data) => {
    setIsRefresh(false)
    changeLoader(true)
    if (clientID) {
      const payloaddata = {
        data: data,
        client_id: clientID
      }

      dispatch(editClient(payloaddata))
        .then(({ payload, error }) => {
          if (payload?.status === 200) {
            toggle()
            changeLoader(false)
            setIsRefresh(true)
            successToast(payload?.data?.status_message || 'Success!')
          } else {
            errorToast(payload?.data?.status_message || error?.message)
            changeLoader(false)
          }
        })
        .catch(() => {
          changeLoader(false)
        })
    } else {
      dispatch(addClient(data))
        .then(({ payload, error }) => {
          if (payload?.status === 200) {
            toggle()
            changeLoader(false)
            setIsRefresh(true)
            successToast(payload?.data?.status_message || 'Success!')
          } else {
            errorToast(payload?.data?.status_message || error?.message)
            changeLoader(false)
          }
        })
        .catch(() => {
          changeLoader(false)
        })
    }
  }

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-12">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="card-body add-vendor pb-4">
              <div className="form-group-item border-0 pb-0 mb-0">
                <div className="row">
                  <div className="col-lg-12 col-sm-12">
                    <div className="form-group">
                      <label>
                        First Name<span className="text-danger"> *</span>
                      </label>
                      <Controller
                        name="first_name"
                        control={control}
                        render={({ field: { value, onChange } }) => (
                          <>
                            <input
                              className="form-control"
                              value={value}
                              type="text"
                              placeholder="Enter First Name"
                              onChange={(val) => {
                                const input = val.target.value
                                const capitalized = capitalizeFirstLetter(input)
                                onChange(capitalized)
                                trigger('first_name')
                              }}
                            />
                            <small>{errors.first_name?.message}</small>
                          </>
                        )}
                        defaultValue=""
                      />
                    </div>
                  </div>
                  <div className="col-lg-12 col-sm-12">
                    <div className="form-group">
                      <label>
                        Last Name<span className="text-danger"> *</span>
                      </label>
                      <Controller
                        name="last_name"
                        control={control}
                        render={({ field: { value, onChange } }) => (
                          <>
                            <input
                              className="form-control"
                              value={value}
                              type="text"
                              placeholder="Enter Last Name"
                              onChange={(val) => {
                                const input = val.target.value
                                const capitalized = capitalizeFirstLetter(input)
                                onChange(capitalized)
                                trigger('last_name')
                              }}
                            />
                            <small>{errors.last_name?.message}</small>
                          </>
                        )}
                        defaultValue=""
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="multi_btn_div">
                <button type="button" className="btn common-outline-btn w-100" onClick={() => toggle()}>
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary common-field-btn w-100">
                  {clientID ? `Update` : `Create`}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default AddEditGhostClient
